<template>
     <div class="yzPhone-page_header">
            <div class="yzPhone-page_title">
                <p class="title">找回登录密码</p>
                <p class="tips">为了保障您的账号安全，请先进行安全验证</p>
            </div>  
            <div class="yzPhone-page_steps">
                <el-steps :active="active" simple process-status="finish" finish-status="success"> 
                    <el-step title="填写账号" icon="el-icon-edit"></el-step>
                    <el-step title="验证手机号"  icon="el-icon-mobile-phone"></el-step>
                    <el-step title="设置新密码"  icon="el-icon-setting"></el-step>
                    <el-step title="完成"  icon="el-icon-success"></el-step>
                </el-steps>
            </div> 
            
        </div>
</template>

<script>
export default {
    name: 'forgetPwdTitle',
    props: ['active'],
    data(){
        return{
           
        }
    },
}
</script>
<style scoped>
.yzPhone-page_title{
    text-align: center;
    width: 782px;
    margin: 0 auto;
    margin-top: 70px;
}
.yzPhone-page_title .title{
    font-size: 24px;
    font-weight: 600;
    color: #383838;
    margin-bottom: 5px;
}
.yzPhone-page_title .tips{
    font-size: 14px;
    color: #999999;
    padding-bottom: 50px;
}
.yzPhone-page_steps{
    width: 782px;
    margin: 0 auto;
}

</style>


// WEBPACK FOOTER //
// src/public/forgetPwdTitle.vue